import { FEATURE_LOYALTY_UI_SINGLETON } from 'features/content/hooks/use-feature-loyalty-ui';

import { useFeatureLoyaltyUiNoRewardQuery } from 'generated/sanity-graphql';

export const useFeaturesLoyaltyNoReward = () => {
  const { data, loading } = useFeatureLoyaltyUiNoRewardQuery({
    variables: { featureLoyaltyUIId: FEATURE_LOYALTY_UI_SINGLETON },
  });
  return {
    data: data?.LoyaltyUI?.noRewardPoints,
    loading,
  };
};
